module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
  return _h('nav', {
    staticClass: "view-controls"
  }, [_h('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showProgress),
      expression: "showProgress"
    }],
    staticClass: "view-controls__wrapper"
  }, [_h('span', {
    staticClass: "view-controls__group"
  }, [_h('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.showMap),
      expression: "!showMap"
    }],
    staticClass: "view-controls__button",
    on: {
      "click": _vm.openMap
    }
  }, ["View Map"]), " ", _h('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showMap),
      expression: "showMap"
    }],
    staticClass: "view-controls__button",
    on: {
      "click": _vm.hideMap
    }
  }, ["Hide Map"])]), " ", _h('ul', {
    staticClass: "view-controls__list"
  }, [_vm._l((_vm.routes), function(item, index) {
    return _h('li', {
      staticClass: "view-controls__item"
    }, [_h('view-link', {
      attrs: {
        "to": {
          name: item.name,
          params: {
            scene: index + 1
          }
        },
        "scene": item.scene,
        "current": _vm.sceneID
      }
    }, [_vm._s(item.name)])])
  })]), " ", _h('span', {
    staticClass: "view-controls__group"
  }, [_h('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showBack),
      expression: "showBack"
    }],
    staticClass: "view-controls__button",
    on: {
      "click": _vm.goBack
    }
  }, ["Back"]), " ", _h('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showNext),
      expression: "showNext"
    }],
    staticClass: "view-controls__button",
    on: {
      "click": _vm.goNext
    }
  }, ["Next"]), " ", _h('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showFinish),
      expression: "showFinish"
    }],
    staticClass: "view-controls__button",
    on: {
      "click": _vm.goFinish
    }
  }, ["Complete"])])]), " ", _h('aside', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showMap),
      expression: "showMap"
    }],
    staticClass: "view-controls__map"
  }, [_h('div', {
    staticClass: "view-controls__map-frame"
  }, [_h('view-map')])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5f2c0395!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ProgressBar.vue
// module id = 219
// module chunks = 2